import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <Section background="charcoal" className="text-center py-32" data-id="element-127">
      <div className="max-w-3xl mx-auto" data-id="element-128">
        <FadeIn data-id="element-129">
          <h2 className="text-5xl md:text-6xl font-serif text-ivory mb-8" data-id="element-130">
            Join the Next Era of Wellness
          </h2>
          <p className="text-xl text-ivory/70 mb-12 font-light" data-id="element-131">
            Whether you are seeking care, providing care, or investing in the
            future of care — there is a place for you here.
          </p>
        </FadeIn>

        <FadeIn delay={200} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-132">
          <a href="https://fem-connect-demo.lovable.app/auth?redirectTo=/&fbclid=PAVERFWAQyUTBleHRuA2FlbQIxMABzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAae4bSfphbEN51QtobTbyS65sNWxLa1apBvz8XwrrlisdfaZd0KwWgwLbqgw1g_aem_TTHgJEgCXa6tLi9zpuxavg" target="_blank" rel="noopener noreferrer" data-id="element-133">
            <Button variant="primary" size="lg" className="w-full sm:w-auto bg-purple-600 text-white hover:bg-purple-700" data-id="element-134">
              Join the Platform
            </Button>
          </a>
          <a href="https://fem-connect-demo.lovable.app/auth?redirectTo=/&fbclid=PAVERFWAQyUTBleHRuA2FlbQIxMABzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAae4bSfphbEN51QtobTbyS65sNWxLa1apBvz8XwrrlisdfaZd0KwWgwLbqgw1g_aem_TTHgJEgCXa6tLi9zpuxavg" target="_blank" rel="noopener noreferrer" data-id="element-135">
            <Button variant="outline" size="lg" className="w-full sm:w-auto border-ivory text-ivory hover:bg-ivory hover:text-charcoal" data-id="element-136">
              Apply to Network
            </Button>
          </a>
        </FadeIn>
      </div>
    </Section>;
}